import {lazy} from 'react';

import LocalShipping from "@material-ui/icons/LocalShipping";
import Help from "@material-ui/icons/Help";
import AtMark from "@material-ui/icons/AlternateEmail";
import Mail from "@material-ui/icons/ContactMail";
import Web from "@material-ui/icons/Web";
import Assignment from "@material-ui/icons/Assignment";
import {ShortText} from "@material-ui/icons";

const Editor = lazy(() => import('views/ShippingAddress/Editor'));
const Delivery = lazy(() => import('views/ShippingAddress/Delivery'));
const Winning = lazy(() => import('views/ShippingAddress/Winning'));
const FaqGeneral = lazy(() => import('views/Faq/General'));
const FaqType = lazy(() => import('views/Faq/Type'));
const ContactGeneral = lazy(() => import('views/Contact/General'));
const ContactType = lazy(() => import('views/Contact/Type'));
const FaqContents = lazy(() => import('views/Faq/Contents'));
const RegisterMail = lazy(() => import('views/Register/Mail'));
const RegisterInfo = lazy(() => import('views/Register/Info'));
const SerialCodeList = lazy(() => import('views/SerialCode/Editor'));
const SerialCodeData = lazy(() => import('views/SerialCode/Data'));
const Survey = lazy(() => import('views/Survey'));
const SurveyResult = lazy(() => import('views/Survey/Result'));
const Refund = lazy(() => import('views/Refund'));


export default [
  {
    collapse: true,
    state: "openShipping",
    name: "配送サービス",
    icon: LocalShipping,
    views: [
      {path: "/project/:name/shipping-address/editor", name: "エディタ", component: Editor, render: true},
      {path: "/project/:name/shipping-address/delivery", name: "配送先一覧", component: Delivery, render: true},
      {path: "/project/:name/shipping-address/winning", name: "当選者一覧", component: Winning, render: true},
    ]
  },
  {
    collapse: true,
    state: "openFaq",
    name: "FAQ管理",
    icon: Help,
    views: [
      {path: "/project/:name/faq/general", name: "全般", component: FaqGeneral, render: true},
      {path: "/project/:name/faq/type", name: "タイプ", component: FaqType, render: true},
      {path: "/project/:name/faq/contents", name: "詳細", component: FaqContents, render: true},
    ]
  },
  {
    collapse: true,
    state: "openContact",
    name: "お問い合わせ管理",
    icon: AtMark,
    views: [
      {path: "/project/:name/contact/general", name: "全般", component: ContactGeneral, render: true},
      {path: "/project/:name/contact/type", name: "タイプ", component: ContactType, render: true},
    ]
  },
  {
    collapse: true,
    state: "openRegister",
    name: "事前登録",
    icon: Mail,
    views: [
      {path: "/project/:name/register/mail", name: "設定", component: RegisterMail, render: true},
      {path: "/project/:name/register/info", name: "登録状況", component: RegisterInfo, render: true},
    ]
  },
  {
    collapse: true,
    state: "openSurvey",
    name: "アンケート機能",
    icon: Assignment,
    views: [
      {path: "/project/:name/survey/editor", name: "リスト", component: Survey, render: true},
      {path: "/project/:name/survey/result/:surveyCode", name: "結果", component: SurveyResult, render: false},
    ]
  },
  {
    collapse: true,
    state: "openSerialCode",
    name: "シリアルコード",
    icon: ShortText,
    views: [
      {path: "/project/:name/serial-code/editor", name: "リスト", component: SerialCodeList, render: true},
      {path: "/project/:name/serial-code/data", name: "詳細", component: SerialCodeData, render: true},
    ]
  },
  {
    path: "/project/:name/refund",
    name: "返金用API",
    icon: Web,
    component: Refund,
  }
]
